import { IndexProfileListItem } from "humboldt";
import * as React from "react";
import Tile from "./tile";

interface TileContentProps {
    action: any;
    profileList: IndexProfileListItem[];
}

class TileContent extends React.Component<TileContentProps> {
    private actionCb = (id: any) => () => {
        const { action } = this.props;
        action(id);
    };

    public render() {
        const { profileList } = this.props;

        const mytiles = profileList.map((profile) => (
            <Tile
                onClick={this.actionCb(profile.uuid)}
                key={profile.uuid}
                active={false}
                text={profile.name}
            />
        ));

        return <div className="TileContent">{mytiles}</div>;
    }
}

export default TileContent;
